/**
 * The colours used to accent the UI.
 */
export const ACCENT_COLOR = {
  main: {
    hue: 200,
    saturation: 10,
    lightness: 70,
  },
  darker: {
    hue: 200,
    saturation: 10,
    lightness: 50,
  },
  contrastText: {
    hue: 200,
    saturation: 10,
    lightness: 20,
  },
  background: {
    hue: 200,
    saturation: 10,
    lightness: 81,
  },
  backgroundContrastText: {
    hue: 200,
    saturation: 4,
    lightness: 29,
  },
};
